import { MESSAGE_APPLICATION_SENT } from 'submodules/api_middleware';
import { MessageType, pushMessage } from 'components/layouts/Toast';
import { FormResponseData } from 'services/user.service';

export const handlePhotoResponse = (
    responsePhoto: FormResponseData,
    setPhoto: (photo: string) => void
): void => {
    if (!responsePhoto) {
        throw new Error('photo_error');
    }

    if (
        responsePhoto.message &&
        responsePhoto.message === MESSAGE_APPLICATION_SENT
    ) {
        pushMessage(
            'photoUploadApplicationSent_message',
            MessageType.SUCCESS,
            'photoUploadApplicationSent_title'
        );
    } else if (responsePhoto.data?.full) {
        setPhoto(responsePhoto.data.full as string);
        pushMessage(
            'photoUploaded_message',
            MessageType.SUCCESS,
            'photoUploaded_title'
        );
    } else {
        throw new Error('photo_error');
    }
};
